"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColumnsController", {
    enumerable: true,
    get: function() {
        return ColumnsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _columnsservice = require("~/services/columns.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ColumnsController = class ColumnsController {
    async columnAdd(context, tableId, body, req) {
        return await this.columnsService.columnAdd(context, {
            tableId,
            column: body,
            req,
            user: req.user
        });
    }
    async columnUpdate(context, columnId, body, req) {
        return await this.columnsService.columnUpdate(context, {
            columnId: columnId,
            column: body,
            req,
            user: req.user
        });
    }
    async columnDelete(context, columnId, req) {
        return await this.columnsService.columnDelete(context, {
            columnId,
            req,
            user: req.user
        });
    }
    async columnGet(context, columnId) {
        return await this.columnsService.columnGet(context, {
            columnId
        });
    }
    async columnSetAsPrimary(context, columnId, req) {
        return await this.columnsService.columnSetAsPrimary(context, {
            columnId,
            req
        });
    }
    async columnsHash(context, tableId) {
        return await this.columnsService.columnsHash(context, tableId);
    }
    async columnBulk(context, tableId, body, req) {
        return await this.columnsService.columnBulk(context, tableId, body, req);
    }
    constructor(columnsService){
        this.columnsService = columnsService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/columns/',
        '/api/v2/meta/tables/:tableId/columns/'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('columnAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ColumnReqType === "undefined" ? Object : _nocodbsdk.ColumnReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnAdd", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/columns/:columnId',
        '/api/v2/meta/columns/:columnId'
    ]),
    (0, _extractidsmiddleware.Acl)('columnUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ColumnReqType === "undefined" ? Object : _nocodbsdk.ColumnReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/columns/:columnId',
        '/api/v2/meta/columns/:columnId'
    ]),
    (0, _extractidsmiddleware.Acl)('columnDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnDelete", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/columns/:columnId',
        '/api/v2/meta/columns/:columnId'
    ]),
    (0, _extractidsmiddleware.Acl)('columnGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnGet", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/columns/:columnId/primary',
        '/api/v2/meta/columns/:columnId/primary'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('columnSetAsPrimary'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('columnId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnSetAsPrimary", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId/columns/hash',
        '/api/v2/meta/tables/:tableId/columns/hash'
    ]),
    (0, _extractidsmiddleware.Acl)('columnsHash'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnsHash", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/columns/bulk',
        '/api/v2/meta/tables/:tableId/columns/bulk'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('columnBulk'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ColumnsController.prototype, "columnBulk", null);
ColumnsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService
    ])
], ColumnsController);
